import React from 'react';
import PropTypes from 'prop-types';
import { MobileRecommendedTargetAmountChart } from '../../RecommendedTargetAmountChart/RecommendedTargetAmountChartContainer';
import MobileTopNavSmallView from '../../MobileTopNav/MobileTopNavSmallView';
import { MobileActionStepsV2 } from '../../FinancialPlan/ActionStepsV2/ActionStepsV2Container';
import { MobileExplanations } from '../../FinancialPlan/Explanations/ExplanationsContainer';
import { createCustomPropType, isNumeric, isUuid } from '../../../js/app/react/validators';
import MobileEditGoalButton from '../MobileEditGoalButton/MobileEditGoalButtonContainer';

const MobileRetirementView = (props) => {
  const {
    fpId, clientId, isCurrentPlan, homePurchaseGoal,
  } = props;
  if (!homePurchaseGoal) {
    return null;
  }

  return (
    <div className="NewFinancialPlan_retirement">
      <MobileTopNavSmallView
        onClick={() => window.history.back()}
        headerText={homePurchaseGoal.GoalName}
      />
      <div className="mobile-content-scrollable-small-topnav-gray">
        <MobileExplanations clientId={clientId} />
        <div className="mobile-consumer-heading-separator">
          {isCurrentPlan ? 'Savings Schedule' : 'Recommended Savings Schedule'}
        </div>
        <section className="chart mobile no-padding-bottom less-padding-left less-padding-right">
          <div className="mobile-recommended-target-amount-wrapper">
            <MobileRecommendedTargetAmountChart
              clientId={clientId}
              data={homePurchaseGoal}
              fpId={fpId}
              isCurrentPlan={isCurrentPlan}
            />
          </div>
        </section>
        <MobileActionStepsV2 clientId={clientId} fpId={fpId} />
        <MobileEditGoalButton clientId={clientId} fpId={fpId} />
      </div>
    </div>
  );
};

MobileRetirementView.propTypes = {
  isCurrentPlan: PropTypes.bool.isRequired,
  clientId: createCustomPropType(isNumeric).isRequired,
  fpId: createCustomPropType(isUuid).isRequired,
  selectedGoalChart: PropTypes.shape({}).isRequired,
  homePurchaseGoal: PropTypes.shape({}).isRequired,
};

export default MobileRetirementView;
